import { render, staticRenderFns } from "./DingTip.vue?vue&type=template&id=d5c0f634&scoped=true"
import script from "./DingTip.vue?vue&type=script&lang=js"
export * from "./DingTip.vue?vue&type=script&lang=js"
import style0 from "./DingTip.vue?vue&type=style&index=0&id=d5c0f634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c0f634",
  null
  
)

export default component.exports